<template>
  <div class="apps">
    <div id="map" style="width:500px;height:100vh;"></div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      title:"地图位置",
      longitude: "",
      latitude: "",
      options:{}
    };
  },
   mounted() {
    console.log("params",this.$route.params);
    this.options = this.$store.state.mapDate
    this.getLocation()
    this.init()
  },
  methods: {
    	//获取定位
		getLocation(){
			var geolocation = new window.qq.maps.Geolocation("WVRBZ-RMI6R-S46WU-WARXB-6V4WO-UWBIO", "myapp");
			geolocation.getLocation(this.showPosition, this.errorPosition);
			
		},
		showPosition(position){
			console.log("position",position);
			this.longitude=position.lng;
			this.latitude=position.lat;
			this.city=position.city;
      this.province=position.province;
		},
		errorPosition(){
			console.log('定位失败');
			//继续定位
			this.getLocation();
		},
		getPosition(){//点击一次获取一次
			this.getLocation()
		},
    init(position) {
      let address = "";
      let that = this;
      var center = new qq.maps.LatLng(this.options.lat,this.options.lng);
      var map = new qq.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: 13,
        disableDefaultUI: true
      });
      var marker = new qq.maps.Marker({
        position: center,
        map: map
      });
      var infoWin = new qq.maps.InfoWindow({
        map: map,
        position: new qq.maps.LatLng(this.options.lat,this.options.lng),
        offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
      });
      var geocoder = new qq.maps.Geocoder({
        complete: function(res) {
          console.log(res);
          address = res.detail.nearPois[0].name;
        }
      });
      qq.maps.event.addListener(map, "click", function(event) {
        this.longitude = event.latLng.getLat();
        this.latitude = event.latLng.getLng();
        console.log("event",event);
        let lat = new qq.maps.LatLng(this.longitude, this.latitude);
        geocoder.getAddress(lat);
        setTimeout(() => {
          infoWin.open();
          infoWin.setContent(
            '<div style="text-align:center;white-space:nowrap;">' +
              address +
              "</div>"
          );
          infoWin.setPosition(event.latLng);
        }, 200);
      });
      let addres = this.options.address
      let name = this.options.name
      let lat = new qq.maps.LatLng(this.options.lat,this.options.lng);
      geocoder.getAddress(lat);
      infoWin.open();
      infoWin.setContent(
        '<div style="text-align:center;white-space:nowrap;font-size:14px;text-align:left">' +
          name +
          "</div>"+
        '<div style="text-align:center;white-space:nowrap;font-size:12px;text-align:left">' +
          addres +
          "</div>"
      );
      // infoWin.setPosition(this.options.lng);

    }
  }
};
</script>
<style scoped>
.apps{
  width: 100%;
  height: 100vh;
  overflow: hidden
}
</style>

